
const Navbar =() =>(
    <div className="navbar">
        <div>(Placeholder Navbar)</div>
        <div>News</div>
        <div>Blog</div>
        <div>Community</div>
        <div>Games</div>
        <div>Videos</div>
    </div>
)

export default Navbar;
